import { MouseEvent, useEffect } from 'react';
import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
import { DragHandleDots2Icon } from '@radix-ui/react-icons';

import { Shot } from '../../../app/entities/shot';
import { useSelection } from '../../../core/contexts/selection.context';
import { getModifier } from '../../../core/services/event.service';

import styles from './unused-shot-card.module.scss';
interface UnusedShotCardProps {
  shot: Shot;
}

export const UnusedShotCard = ({ shot }: UnusedShotCardProps) => {
  const { select, elements } = useSelection();

  const { transform, isDragging, listeners, attributes, setNodeRef } = useDraggable({
    id: shot._id,
    data: {
      type: 'boneyard-shot',
      elements: elements.length ? elements : [shot._id],
      select,
    },
  });

  const style = {
    transform: CSS.Transform.toString(transform),
  };

  const isSelected = elements.includes(shot._id);

  useEffect(() => {
    if (!isSelected && isDragging) {
      select(shot._id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSelected, isDragging]);

  const handleSingleClick = (e: MouseEvent) => {
    const modifier = getModifier(e.nativeEvent);
    select(shot._id, modifier);
  };

  /**
   * Find the title property id
   */
  const titleProperty = shot.project.properties.find((el) => el.key === 'title');
  const title = titleProperty ? shot.getProperty(titleProperty._id) : undefined;

  return (
    <div
      className={styles['shot-card']}
      ref={setNodeRef}
      style={style}
      data-dragging={isDragging}
      data-selected={isSelected}
      onClick={handleSingleClick}
      {...attributes}
      {...listeners}
    >
      <DragHandleDots2Icon />
      <div className={styles['cover']} data-no-cover={!shot.cover?.src}>
        {shot.cover?.src && <img src={shot.cover?.src} alt={shot.title || 'shot image'} />}
      </div>
      <div className={styles['shot-title']} data-no-title={!title}>
        {title || 'No title'}
      </div>
    </div>
  );
};
